module.exports = __webpack_public_path__ + "static/media/skateboard.2acca348.jpg";